import styled, { css } from 'styled-components';
import { devices } from '../../utilities/responsive';

interface ContainerProps {
    flex?: boolean;
    justifyCenter?: boolean;
    hasBg?: boolean;
    twoCol?: boolean;
}

export const Container = styled.div<ContainerProps>`
    max-width: 120rem;
    width: 100%;
    position: relative;
    padding: 0 2vw;
    height: 100%;
    margin: 0 auto;

    ${({ flex }) => flex && css`
        display: flex;
        align-items: center;
    `}

    ${({ justifyCenter }) => justifyCenter && css`
        justify-content: center;
    `}

    ${({ hasBg }) => hasBg && css`
        background: rgba(0, 0, 0, .05);
        padding: 50px 50px 80px 50px;
        margin: 50px 0;
    `}

    ${({ twoCol }) => twoCol && css`
        display: grid;
        margin: 50px 0;
        padding: 0;
        grid-template-columns: repeat(2, 1fr);
        gap: 30px;
    `}

    @media ${devices.desktopLg} {
        max-width: 154rem;
    }

    @media ${devices.phone} {
        padding: 0 4vw;
    }
`;